import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { PostHogProvider } from './contexts/PostHogContext'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import './styles/globals.css'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <PostHogProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PostHogProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
